<template>
  <div class="subheader"
       :class="[preset]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardSubheader",
  props: {
    value: {
      type: Object,
      default: null,
    },
    paddings: {
      type: Boolean,
      default: true,
    },
    preset: {
      type: String,
      default: 'd-flex flex-wrap align-center'
    }
  }
}
</script>

<style lang="scss" scoped>
    .subheader {
      justify-content: space-between;
    }
</style>